
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Contacto y consulta',
      description: 'Llámanos o escríbenos por WhatsApp. Te atendemos rápidamente para entender tu proyecto.',
    },
    {
      number: '02',
      title: 'Visita y medición',
      description: 'Visitamos tu espacio en Barcelona para tomar medidas y evaluar las necesidades específicas.',
    },
    {
      number: '03',
      title: 'Presupuesto detallado',
      description: 'Recibe un presupuesto claro sin compromiso con todos los detalles del trabajo.',
    },
    {
      number: '04',
      title: 'Ejecución profesional',
      description: 'Realizamos la instalación de pladur con acabado impecable y limpieza diaria.',
    },
    {
      number: '05',
      title: 'Entrega y garantía',
      description: 'Revisión final del trabajo y garantía de calidad en todos nuestros servicios.',
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.6 },
    },
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center space-x-3 mb-4">
            <div className="w-2 h-2 bg-primary rounded-full"></div>
            <h2 className="text-primary-dark text-5xl md:text-6xl font-serif font-bold">
              Nuestro proceso de trabajo
            </h2>
          </div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Trabajamos de forma ordenada y transparente para garantizar los mejores resultados en cada proyecto de <Link to="/servicios" className="text-primary hover:underline font-semibold">instalación de pladur en Barcelona</Link>.
          </p>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="space-y-4"
        >
          {steps.map((step, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              className="relative bg-gray-50 rounded-xl p-8 hover:bg-gray-100 transition-colors duration-300"
            >
              <div className="absolute -left-4 top-1/2 -translate-y-1/2 text-[72px] font-extrabold text-primary opacity-15 pointer-events-none">
                {step.number}
              </div>
              <div className="ml-16">
                <h3 className="text-primary-dark text-xl font-bold mb-2">
                  {step.title}
                </h3>
                <p className="text-gray-600 text-[15px]">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-gray-600 mb-6">
            Conoce más sobre <Link to="/empresa" className="text-primary hover:underline font-semibold">nuestra empresa</Link> y cómo trabajamos, o <Link to="/contacto" className="text-primary hover:underline font-semibold">solicita tu presupuesto</Link> ahora.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessSection;
